import { NAVIGATION_ITEM_SHORTNEWS } from '@/config/constants';

type BuildShortnewsUrlInput = {
	omId?: string | null;
	slug?: string | null;
};

const SLUG_ROWID_SEPARATOR = '%2C';

/**
 * Generates an absolute URL for a shortnews item based on the provided parameters.
 *
 * @param {BuildShortnewsUrlInput} omId - The ID of the shortnews item.
 * @param {BuildShortnewsUrlInput} slug - The slug of the shortnews item.
 * @param {string} appUrl - The base URL of the application.
 * @return {string} The absolute URL for the shortnews item.
 */
export const buildItemUrlAbsolute = (params: BuildShortnewsUrlInput, appUrl: string) => {
	const { omId, slug } = params;

	if (!omId || !slug) {
		return `${appUrl}${NAVIGATION_ITEM_SHORTNEWS.path}`;
	}

	const path = `/meldung${slug.startsWith('/') ? '' : '/'}${slug}${SLUG_ROWID_SEPARATOR}${omId}`;

	return `${appUrl}${path}`;
};
